// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"Footer_footerSection__5p5zf","content":"Footer_content__A_k7j","links":"Footer_links__EdFOD","disclaimer":"Footer_disclaimer__54_gc","logo":"Footer_logo__jTKUR"};